import { render, staticRenderFns } from "./addReturnAd.vue?vue&type=template&id=06459b96&"
import script from "./addReturnAd.vue?vue&type=script&lang=js&"
export * from "./addReturnAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06459b96')) {
      api.createRecord('06459b96', component.options)
    } else {
      api.reload('06459b96', component.options)
    }
    module.hot.accept("./addReturnAd.vue?vue&type=template&id=06459b96&", function () {
      api.rerender('06459b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/addReturnAd.vue"
export default component.exports